export default __webpack_public_path__ + "static/media/Cuirass of Faith.79cb3b9d.jpg";